import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const basePrefix = () => `${process.env.REACT_APP_APIUrl}${NetworkConfiguration.ADMIN_ABANDONED_LEADS}`;

const getAbandonedLeads = (stage, queryParams = "") => {
  return new Promise((resolve, reject) => {
    callAPI(`${basePrefix()}/${stage}${queryParams}`, "GET", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getAbandonedLeadById = (stage, id) => {
  return new Promise((resolve, reject) => {
    callAPI(`${basePrefix()}/${stage}/${id}`, "GET", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const adminProceedAbandonedOrder = (stage, leadId, payload = {}) => {
  return new Promise((resolve, reject) => {
    callAPI(
      `${basePrefix()}/${stage}/${leadId}/proceed-order`,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(payload)
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const updateAbandonedLeadAddress = (stage, leadId, shippingAddress, billingAddress) => {
  return new Promise((resolve, reject) => {
    callAPI(
      `${basePrefix()}/${stage}/${leadId}/address`,
      "PATCH",
      { "Content-Type": "application/json" },
      JSON.stringify({ shippingAddress, billingAddress })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const abandonedLeadApiService = {
  getAbandonedLeads,
  getAbandonedLeadById,
  adminProceedAbandonedOrder,
  updateAbandonedLeadAddress,
};
